var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 202.4 36.9",
    style: {
      enableBackground: "new 0 0 202.4 36.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#ECE7FD;}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.3983,
    y1: 1.1,
    x2: 19.3983,
    y2: 38,
    gradientTransform: "matrix(1 0 0 -1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A05FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,36.9L28.6,36.9h-16c-1.6,0-3.1-0.9-3.9-2.3L0.6,20.7c-0.8-1.4-0.8-3.1,0-4.4L8.7,2.2 C9.5,0.8,10.9,0,12.5,0h16.1c1.6,0,3.2,0.9,4,2.3l5.8,10.1c0.1,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.2-0.2,0.3l-2,1.1 c-2.1,1.2-4.8,0.5-6-1.6L27,7.1h-6.4v22.7H27l3.3-5.7l-5.5-3.2c-1.1-0.6-1.8-1.8-1.8-3.1v-5.4c0-0.2,0.1-0.3,0.2-0.4 c0.2-0.1,0.3-0.1,0.5,0L37,19.6c0.9,0.5,1.5,1.3,1.7,2.2s0.1,1.9-0.4,2.8l-5.8,10C31.8,36,30.3,36.9,28.6,36.9z M12.6,35.9h16 c1.3,0,2.5-0.7,3.2-1.8l5.8-10c0.4-0.6,0.5-1.3,0.3-2s-0.6-1.3-1.2-1.6L34,19l-9.8-5.7v4.5c0,0.9,0.5,1.8,1.3,2.3l5.9,3.4 c0.2,0.1,0.3,0.4,0.2,0.7l-3.7,6.4c-0.1,0.2-0.3,0.2-0.4,0.2H20c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0-0.1V6.6c0-0.3,0.2-0.5,0.4-0.5 c0,0,0,0,0.1,0h7.5c0.2,0,0.3,0.1,0.4,0.2l3.3,5.7c0.9,1.6,3,2.2,4.7,1.3l1.6-0.9l-5.6-9.6c-0.8-1.1-2-1.8-3.3-1.8l0,0H12.5 c-1.2,0-2.3,0.6-2.9,1.7L1.5,16.8c-0.6,1.1-0.6,2.4,0,3.4l8.1,13.9C10.2,35.2,11.3,35.9,12.6,35.9C12.6,35.9,12.6,35.9,12.6,35.9z  M13.7,30.8c-0.2,0-0.3-0.1-0.4-0.2L6.4,18.8c-0.1-0.2-0.1-0.4,0-0.6l6.9-11.8c0.1-0.2,0.3-0.3,0.6-0.2c0.2,0.1,0.4,0.3,0.4,0.5 v23.7c0,0.2-0.2,0.4-0.4,0.5C13.8,30.8,13.7,30.8,13.7,30.8z M7.4,18.4l5.8,10V8.5C13.2,8.5,7.4,18.4,7.4,18.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.4,12.4v-1.6H78v15.1c0,2.5-0.8,4.4-2.4,5.7s-3.6,1.9-5.9,1.9c-3.6,0-6.1-1.3-7.5-3.8l4.1-2.4 c0.7,1.3,2,2,3.6,2c1.1,0,2-0.3,2.7-0.9c0.6-0.6,0.9-1.4,0.9-2.5v-1.5c-1.1,1.4-2.7,2.1-4.6,2.1c-2.2,0-4.1-0.8-5.6-2.4 s-2.2-3.5-2.2-5.7s0.7-4.1,2.2-5.7s3.3-2.4,5.6-2.4C70.8,10.3,72.3,11,73.4,12.4z M66.8,21c0.7,0.7,1.7,1,2.8,1s2-0.3,2.8-1 c0.7-0.7,1.1-1.5,1.1-2.7c0-1-0.4-2-1.1-2.7c-0.7-0.7-1.7-1-2.8-1s-2,0.3-2.8,1c-0.7,0.7-1.1,1.5-1.1,2.7S66.1,20.4,66.8,21z  M86.3,10.7v2.8c0.3-1,0.9-1.8,1.8-2.3c0.9-0.6,1.9-0.8,3-0.8v5.4c-1.2-0.2-2.3,0-3.3,0.6s-1.5,1.6-1.5,3v7.2h-4.8V10.7H86.3z  M104.4,12.2v-1.5h4.8v15.9h-4.8v-1.5c-1.1,1.3-2.7,1.9-4.7,1.9c-2.1,0-3.9-0.8-5.4-2.4s-2.2-3.6-2.2-6s0.7-4.3,2.2-5.9 s3.3-2.4,5.4-2.4C101.7,10.3,103.3,10.9,104.4,12.2z M96.8,18.7c0,1.2,0.3,2.1,1,2.8s1.6,1,2.7,1s2-0.3,2.7-1s1-1.6,1-2.8 s-0.3-2.1-1-2.8s-1.6-1-2.7-1s-2,0.3-2.7,1C97.2,16.6,96.8,17.5,96.8,18.7z M122.2,10.3c2.1,0,3.9,0.8,5.4,2.4s2.2,3.6,2.2,5.9 c0,2.4-0.7,4.4-2.2,6s-3.3,2.4-5.4,2.4s-3.6-0.6-4.7-1.9V33h-4.8V10.7h4.8v1.5C118.5,10.9,120.1,10.3,122.2,10.3z M118.5,21.5 c0.7,0.7,1.6,1,2.7,1s2-0.3,2.7-1s1.1-1.6,1.1-2.8s-0.4-2.1-1.1-2.8s-1.6-1-2.7-1s-2,0.3-2.7,1s-1,1.6-1,2.8 C117.4,19.9,117.8,20.8,118.5,21.5z M141.8,10.3c1.7,0,3.1,0.6,4.2,1.7c1.1,1.2,1.7,2.8,1.7,4.8v9.8H143v-9.1c0-0.9-0.3-1.6-0.8-2.1 s-1.2-0.8-2-0.8c-0.9,0-1.7,0.3-2.2,0.8c-0.5,0.6-0.8,1.4-0.8,2.4v8.7h-4.8V4.4h4.8v7.9C138.2,10.9,139.7,10.3,141.8,10.3z  M155.8,26.6H151V3.4h4.8C155.8,3.4,155.8,26.6,155.8,26.6z M164.1,26.6h-4.8V10.7h4.8V26.6z M176.9,10.3c1.7,0,3.1,0.6,4.2,1.7 c1.1,1.2,1.7,2.8,1.7,4.8v9.8H178v-9.1c0-0.9-0.3-1.6-0.8-2.1s-1.2-0.8-2-0.8c-0.9,0-1.7,0.3-2.2,0.8c-0.5,0.6-0.8,1.4-0.8,2.4v8.7 h-4.8V10.7h4.8v1.5C173.3,10.9,174.8,10.3,176.9,10.3L176.9,10.3z M197.6,12.2v-1.5h4.8V33h-4.8v-7.9c-1.1,1.3-2.7,1.9-4.7,1.9 c-2.1,0-3.9-0.8-5.4-2.4s-2.2-3.6-2.2-6s0.7-4.3,2.2-5.9s3.3-2.4,5.4-2.4S196.5,10.9,197.6,12.2z M190.1,18.7c0,1.2,0.3,2.1,1,2.8 s1.6,1,2.7,1s2-0.3,2.7-1s1-1.6,1-2.8s-0.3-2.1-1-2.8s-1.6-1-2.7-1s-2,0.3-2.7,1S190.1,17.5,190.1,18.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.5835,
    y1: 7.8076,
    x2: 187.5835,
    y2: 3.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A05FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.9,4.2V3.6h0.9v4.1h-0.9V7.1c-0.3,0.5-0.8,0.7-1.4,0.7c-0.6,0-1.1-0.2-1.5-0.6s-0.6-0.9-0.6-1.5 s0.2-1.1,0.6-1.5s0.9-0.6,1.5-0.6C188.1,3.5,188.6,3.7,188.9,4.2z M186.7,6.6c0.2,0.2,0.6,0.4,0.9,0.4s0.7-0.1,0.9-0.4 c0.2-0.3,0.4-0.6,0.4-0.9s-0.1-0.7-0.4-0.9c-0.2-0.3-0.6-0.4-0.9-0.4s-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.6-0.4,0.9 C186.3,6,186.4,6.3,186.7,6.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.9102,
    y1: 9.3501,
    x2: 193.9102,
    y2: 3.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A05FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194,3.5c0.6,0,1,0.2,1.5,0.6c0.4,0.4,0.6,0.9,0.6,1.5c0,0.6-0.2,1.1-0.6,1.5s-0.9,0.6-1.5,0.6 c-0.6,0-1.1-0.2-1.4-0.7v2.2h-0.9V3.6h0.9v0.6C192.9,3.7,193.4,3.5,194,3.5z M193,6.6c0.2,0.2,0.6,0.4,0.9,0.4s0.7-0.1,0.9-0.4 c0.2-0.3,0.4-0.6,0.4-0.9s-0.1-0.7-0.4-0.9c-0.2-0.3-0.6-0.4-0.9-0.4s-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.6-0.4,0.9 C192.6,6,192.7,6.3,193,6.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.0049,
    y1: 9.3501,
    x2: 200.0049,
    y2: 3.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A05FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.1,3.5c0.6,0,1,0.2,1.5,0.6c0.4,0.4,0.6,0.9,0.6,1.5c0,0.6-0.2,1.1-0.6,1.5s-0.9,0.6-1.5,0.6 c-0.6,0-1.1-0.2-1.4-0.7v2.2h-0.9V3.6h0.9v0.6C199,3.7,199.5,3.5,200.1,3.5z M199.1,6.6c0.2,0.2,0.6,0.4,0.9,0.4s0.7-0.1,0.9-0.4 c0.2-0.3,0.4-0.6,0.4-0.9s-0.1-0.7-0.4-0.9c-0.2-0.3-0.6-0.4-0.9-0.4s-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.6-0.4,0.9 C198.7,6,198.8,6.3,199.1,6.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2602d38a5bf31dfb5fbc40f929e13d33.svg";
export { ForwardRef as ReactComponent };